import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Typed from "typed.js";

const Introduction = () => {
  const typedElementLarge = useRef(null);
  const typedElementSmall = useRef(null);

  useEffect(() => {
    const typedLarge = new Typed(typedElementLarge.current, {
      strings: ["Frontend", "React", "MERN", "JavaScript"],
      typeSpeed: 70,
      backSpeed: 80,
      loop: true,
    });

    const typedSmall = new Typed(typedElementSmall.current, {
      strings: ["Frontend", "React", "MERN", "JavaScript"],
      typeSpeed: 70,
      backSpeed: 80,
      loop: true,
    });

    return () => {
      typedLarge.destroy();
      typedSmall.destroy();
    };
  }, []);

  return (
    <motion.div
      className="mt-2"
      whileInView={{ opacity: 1, translateX: 0 }}
      initial={{ opacity: 0, translateX: "-100%" }}
      transition={{ duration: 0.6 }}
      viewport={{ once: false }}
    >
      <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-dark dark:text-light">
        👋 Hi, I'm Kailash,
      </h1>

      {/* Large screen text */}
      <p className="hidden sm:block mt-4 lg:mt-6 text-md lg:text-lg xl:text-xl text-dark dark:text-light leading-relaxed">
        A passionate{" "}
        <span className="text-yellow-500" ref={typedElementLarge}></span>{" "}
        Developer with a focus on the JavaScript ecosystem, especially React and
        Node.js. I love building intuitive, high-performance web applications,
        enhancing user experiences, and staying up to date with web development
        trends.
      </p>

      {/* Mobile screen text */}
      <p className="text-sm sm:hidden mt-4 text-dark dark:text-light leading-relaxed">
        A passionate{" "}
        <span className="text-yellow-500" ref={typedElementSmall}></span>{" "}
        Developer with a focus on the JavaScript ecosystem, especially React and
        Node.js. I enjoy creating high-performance web applications and seamless
        user experiences.
      </p>
    </motion.div>
  );
};

export default Introduction;
